import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetIndividualTaxInformationStatusRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetIndividualTaxInformationStatusResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getIndividualTaxInformationStatus = (
  request: GetIndividualTaxInformationStatusRequest,
  options?: CashRequestOptions
) =>
  post<GetIndividualTaxInformationStatusRequest, GetIndividualTaxInformationStatusResponse>(
    '/2.0/cash/get-individual-tax-information-status',
    request,
    { ...options, rejectOnError: true }
  )
